/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationTypeModel } from '../../models/organization-type-model';

export interface OrganizationTypeIdGet$Params {
  id: string;
}

export function organizationTypeIdGet(http: HttpClient, rootUrl: string, params: OrganizationTypeIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<OrganizationTypeModel>> {
  const rb = new RequestBuilder(rootUrl, organizationTypeIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<OrganizationTypeModel>;
    })
  );
}

organizationTypeIdGet.PATH = '/OrganizationType/{id}';
